export const SET_STATUS = 'SET_STATUS'
export const RESET_STATUS = 'RESET_STATUS'
